/**
 * Форматирование чисел
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
window.number_format = function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {
	let sign = number < 0 ? '-' : '';

	let s_number = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + "";
	let len = s_number.length;
	let tchunk = len > 3 ? len % 3 : 0;

	let ch_first = (tchunk ? s_number.substr(0, tchunk) + thousands_sep : '');
	let ch_rest = s_number.substr(tchunk)
		.replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
	let ch_last = decimals ?
		dec_point + (Math.abs(number) - s_number)
			.toFixed(decimals)
			.slice(2) : '';

	return sign + ch_first + ch_rest + ch_last;
};

/**
 *
 * @param value
 * @param decimals
 * @returns {string}
 */
window.output_numbers = function (value, decimals = 0) {
	let val = number_format(value, decimals, '.', ' ');

	if (decimals > 0) {
		let s = '0'.repeat(decimals);
		let re = new RegExp("\." + s + '$');
		val = val.replace(re, '');
	}

	return val;
};

/**
 * Разные формы слов
 * @param n
 * @param forms
 * @returns {*}
 */
window.getWordForm = function (n, forms) {
	if (n > 0) {
		n = Math.abs(n) % 100;
		let n1 = n % 10;
		if (n > 10 && n < 20) return forms[2];
		if (n1 > 1 && n1 < 5) return forms[1];
		if (n1 === 1) return forms[0];
	}
	return forms[2];
};

window.output_wordform = function (n, forms) {
	return n + ' ' + getWordForm(n, forms);
};

/**
 * Формат денег
 * @param money
 * @param decimals
 * @returns {string}
 */
window.output_money = function (money, decimals = 0) {
	return output_numbers(money, decimals) + ' руб.';
};

window.output_roubles = function (money, decimals = 2) {
	return output_numbers(money, decimals) + ' ₽';
};

/**
 * Формат телефона
 * @param phone
 */
window.clearPhone = function (phone) {
	if (phone.indexOf('+7') !== -1) {
		return phone.replace(/[^+\d]/g, '');
	} else {
		return phone.replace(/\D/g, '');
	}
}

window.phoneCall = function (phone) {
	return 'tel:' + clearPhone(phone)
}

/**
 * Рандомная строка
 * @param length
 * @returns {string}
 */
window.str_random = function (length) {
	let result           = '';
	let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let charactersLength = characters.length;
	for ( let i = 0; i < length; i++ ) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}

	return result;
};

/**
 * Консоль
 * @param type
 * @param arr
 * @returns {boolean}
 * @constructor
 */
window.VGLog = function (type, arr = []) {
	if (!type) return false;

	switch (type) {
		case 'error':
			arr.forEach(function (item) {
				console.error(item);
			});
			break;
		case 'debug':
			arr.forEach(function (item) {
				console.debug(item);
			});
			break;
		case 'success':
			if (arr.length) {
				arr.forEach(function (item) {
					console.log("%c" + item, "color: green;");
				});
			}
			break;
		default:
			console.log(type);
			break;
	}
};

/**
 * @param url
 * @param title
 * @param w
 * @param h
 * @returns {WindowProxy}
 */
window.popupwindow = function (url, title, w, h) {
	let left = (screen.width / 2) - (w / 2),
		top = (screen.height / 2) - (h / 2);

	return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
};

/**
 *
 * @param text
 * @param enToRu
 * @returns {*}
 */
window.transliterate = function (text, enToRu) {
	let ru = "й ц у к е н г ш щ з х ъ ф ы в а п р о л д ж э я ч с м и т ь б ю".split(/ +/g),
		en = "q w e r t y u i o p [ ] a s d f g h j k l ; ' z x c v b n m , .".split(/ +/g),
		x;

	for (x = 0; x < ru.length; x++) {
		text = text.split(enToRu ? en[x] : ru[x]).join(enToRu ? ru[x] : en[x]);
		text = text.split(enToRu ? en[x].toUpperCase() : ru[x].toUpperCase()).join(enToRu ? ru[x].toUpperCase() : en[x].toUpperCase());
	}

	return text;
};

/**
 *
 * @param word
 * @param enToRu
 * @returns {string}
 */
window.translit = function (word, enToRu) {
	let answer = "", a = {};

	a["Ё"]="YO";a["Й"]="I";a["Ц"]="TS";a["У"]="U";a["К"]="K";a["Е"]="E";a["Н"]="N";a["Г"]="G";a["Ш"]="SH";a["Щ"]="SCH";a["З"]="Z";a["Х"]="H";a["Ъ"]="'";
	a["ё"]="yo";a["й"]="i";a["ц"]="ts";a["у"]="u";a["к"]="k";a["е"]="e";a["н"]="n";a["г"]="g";a["ш"]="sh";a["щ"]="sch";a["з"]="z";a["х"]="h";a["ъ"]="'";
	a["Ф"]="F";a["Ы"]="I";a["В"]="V";a["А"]="a";a["П"]="P";a["Р"]="R";a["О"]="O";a["Л"]="L";a["Д"]="D";a["Ж"]="ZH";a["Э"]="E";
	a["ф"]="f";a["ы"]="i";a["в"]="v";a["а"]="a";a["п"]="p";a["р"]="r";a["о"]="o";a["л"]="l";a["д"]="d";a["ж"]="zh";a["э"]="e";
	a["Я"]="Ya";a["Ч"]="CH";a["С"]="S";a["М"]="M";a["И"]="I";a["Т"]="T";a["Ь"]="'";a["Б"]="B";a["Ю"]="YU";
	a["я"]="ya";a["ч"]="ch";a["с"]="s";a["м"]="m";a["и"]="i";a["т"]="t";a["ь"]="'";a["б"]="b";a["ю"]="yu";

	if (enToRu) {
		let res = [];
		for(let k in a) {
			res[a[k]] = k;
		}
		a = res;
	}

	for (let i in word){
		if (word.hasOwnProperty(i)) {
			if (a[word[i]] === undefined){
				answer += word[i];
			} else {
				answer += a[word[i]];
			}
		}
	}
	return answer;
}

window.mergeTwoJsonObj = function ( obj1, obj2 ){
	var obj3 = [];
	for (var index in obj1) {
		obj = {name: obj1[index].name, value: obj1[index].value};
		obj3.push(obj);
	}
	for (var index in obj2) {
		obj = {name: obj2[index].name, value: obj2[index].value};
		var isExist = false;
		var existAt;

		for (var j in obj3) {
			if( obj3[j].name === obj2[index].name){
				isExist = true;
				existAt  = j;
				break;
			}
		}

		if(!isExist) {
			obj3.push(obj);
		} else {
			obj3[j].value = obj2[index].value;
		}

	}

	obj3 = JSON.stringify(obj3);
	obj3 = JSON.parse(obj3);

	return obj3;
};

/**
 * Represents an event listener attached to the global window object.
 * Use this to handle or respond to specific events dispatched by the window.
 */
window.listener = function (event, el, callback) {
	document.addEventListener(event, function (e) {
		let selectors = document.body.querySelectorAll(el),
			element = e.target,
			index = -1;

		while (element && ((index = Array.prototype.indexOf.call(selectors, element)) === -1)) {
			element = element.parentElement;
		}

		if (index > -1) {
			(function () {
				if (typeof callback === "function") {
					callback(element, e);
				}

				// Действия после выполнения события будут срабатывать, т.к. preventDefault закомментирован...
				//e.preventDefault();
			}).call(element, e);
		}
	});
};

/**
 * Глубокое объединение объектов
 * @param objects
 * @returns {*}
 */
window.mergeDeepObject = function (...objects) {
	const isObject = obj => obj && typeof obj === 'object';

	if (!isObject) return;

	return objects.reduce((prev, obj) => {
		Object.keys(obj).forEach(key => {
			const pVal = prev[key];
			const oVal = obj[key];

			if (Array.isArray(pVal) && Array.isArray(oVal)) {
				prev[key] = pVal.concat(...oVal);
			}
			else if (isObject(pVal) && isObject(oVal)) {
				prev[key] = mergeDeepObject(pVal, oVal);
			}
			else {
				prev[key] = oVal;
			}
		});

		return prev;
	}, {});
}

/**
 *
 */
window.getDataAttribute = function (element) {
	if (!element || !element.attributes) {
		return {};
	}

	return Array.from(element.attributes).reduce((prev, attr) => {
		if (!attr.name.startsWith('data-')) {
			return prev;
		}

		const key = attr.name
			.slice(5)
			.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());

		prev[key] = attr.value;

		return prev;
	}, {});
}
